/* global appdata */

import { TweenLite } from 'gsap'
import mapboxgl from 'mapbox-gl/dist/mapbox-gl.js'
import map from 'lodash/map'

export default {
    mapLoad() {

        if (!('remove' in Element.prototype)) {
            Element.prototype.remove = () => {
              if (this.parentNode) {
                  this.parentNode.removeChild(this)
              }
            }
        }

        const listings = document.querySelectorAll('.listings-sidebar__init')

        mapboxgl.accessToken = 'pk.eyJ1Ijoidml0YWxhZ2VuY3kiLCJhIjoiY2pzeXMxdHh2MHplcjQ0b2YwdjZqc2ljeSJ9.ocanScMc7nrOCDD8SLOIiA'

        const mapL = new mapboxgl.Map({
            container: 'map-locations',
            style: 'mapbox://styles/vitalagency/ckldu1rpf2ixl18mp8sf1m530',
            center: [-7.1454367,54.3137209],
            zoom: 1,
            scrollZoom: false,
        })

        const geojson = {
            'type': 'FeatureCollection',
            'features': [],
        }
        map(appdata.map, item => {
            if(item.location){
                let dataItem = {
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [item.location.longitude, item.location.latitude],
                    },
                    properties: {
                        title: item.title,
                    },
                }
                if(item.information){
                    dataItem.properties.information = item.information
                }
                if(item.colour){
                    dataItem.properties.colour = item.colour
                }
                if(item.image){
                    dataItem.properties.image = item.image
                }


                geojson.features.push(dataItem)

            }
        })


        let squarebox = {
            min: [999999999999999, 999999999999999],
            max: [-999999999999999, -999999999999999],
        }

        map(appdata.map, item => {
            if(item.location){
                if(item.location.longitude < squarebox.min[0]){
                    squarebox.min[0] = Number(item.location.longitude)
                }
                if(item.location.latitude < squarebox.min[1]){
                    squarebox.min[1] = Number(item.location.latitude)
                }
                if(item.location.longitude > squarebox.max[0]){
                    squarebox.max[0] = Number(item.location.longitude)
                }
                if(item.location.latitude > squarebox.max[1]){
                    squarebox.max[1] = Number(item.location.latitude)
                }

            }

        })
        const bbox = [
            [squarebox.min[0], squarebox.min[1]],
            [squarebox.max[0], squarebox.max[1]],
        ]


        mapL.on('load', () => {

                mapL.addSource('places', {
                  'type': 'geojson',
                  'data': geojson,
                })
                buildLocationList(geojson);

                fitMap(bbox)
                $('.zoom-out').off('click')
                $('.zoom-out').on('click', function(e){
                    e.preventDefault()
                    fitMap(bbox)
                    $(document.body).removeClass('map-active')
                })
                $(window).resize()
        })

        geojson.features.forEach(function(marker, i) {
            let el = document.createElement('div')
            let colour = '#333333'
            el.id = 'marker-' + i
            el.className = 'marker'
            if(marker.properties.colour){
                colour = marker.properties.colour
            }

            el.innerHTML = `
                <svg width="35" height="35" xmlns="http://www.w3.org/2000/svg"><circle class="circle first-circle" fill="${colour}" cx="17.5" cy="17.5" r="6"/><g fill="${colour}" fill-rule="evenodd" opacity=".6"><circle cx="17.5" cy="17.5" r="3.712"><animate attributeName="r" begin="0s" dur="3s" values="0;15" keyTimes="0;1" keySplines="0.1,0.2,0.3,1" calcMode="spline" repeatCount="indefinite"/><animate attributeName="opacity" begin="0s" dur="3s" values="0;.3;.3;0" repeatCount="indefinite"/></circle><circle cx="17.5" cy="17.5" r="11.558"><animate attributeName="r" begin="-1s" dur="3s" values="0;15" keyTimes="0;1" keySplines="0.1,0.2,0.3,1" calcMode="spline" repeatCount="indefinite" opacity=".8"/><animate attributeName="opacity" begin="-1s" dur="3s" values="0;.3;.3;0" repeatCount="indefinite"/></circle></g></svg>
            `
            new mapboxgl.Marker(el)
                .setLngLat(marker.geometry.coordinates)
                .addTo(mapL)

            el.addEventListener('click', function(e){

                $(document.body).addClass('map-active')
                flyToStore(marker)

                const activeItem = document.getElementsByClassName('active')

                e.stopPropagation()
                if (activeItem[0]) {
                   activeItem[0].classList.remove('active')
                }

                const listing = document.getElementById('listing-' + i)
                listing.classList.add('active')

            })
        })

        function fitMap(box){
                mapL.fitBounds(box, {
                    padding: {
                        top: 40,
                        bottom: 40,
                        left: 40,
                        right: 40,
                    },
                    bearing: 0,
                    pitch: 0,
                })
        }


        function flyToStore(currentFeature) {
            mapL.flyTo({
                center: currentFeature.geometry.coordinates,
                zoom: 5,
                speed: 0.85,
                pitch: 55,
                bearing: -15,
            })
        }




        function buildLocationList(data) {

            for (let i = 0; i < data.features.length; i++) {
                let currentFeature = data.features[i];
                let prop = currentFeature.properties;


                let listing = listings[0].appendChild(document.createElement('div'));
                listing.className = 'listing-item';
                listing.id = 'listing-' + i;


                if(prop.image){
                    $('#listing-' + i).append('<div class="listing-item__image object-fix">' + prop.image + '</div>')
                }

                $('#listing-' + i).append('<div class="listing-item__content"></div>')

                $('#listing-' + i + ' .listing-item__content').append('<h3 class="title">' + prop.title + '</h3>')



                if(prop.information){
                    $('#listing-' + i + ' .listing-item__content').append('<div class="information">' + prop.information + '</div>')
                }


            }

        }

    },
    init() {
        this.mapLoad()
    },

};
